import styled from "styled-components";

export const Container = styled.div`
  font-weight: bold;
  font-size: 12px;
`;
